import { render } from "./Signup.vue?vue&type=template&id=ed5d307c&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=ed5d307c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed5d307c"

export default script